import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import TooltipButton from 'components/TooltipButton';
var ToolbarButton = function ToolbarButton(props) {
  return /*#__PURE__*/React.createElement(TooltipButton, _extends({}, props, {
    square: true,
    size: "large",
    variant: "transparent"
  }));
};
export default ToolbarButton;